import { Component, OnInit } from '@angular/core';
import { ExcelService } from '../Services/excel.service';
import Swal from 'sweetalert2';
import { NgxSpinnerService } from 'ngx-spinner';
import { IFiltrosReporte } from '../interfaces/FiltrosReporte';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { RegistroVentasService } from '../Services/registro-ventas.service';
import { ErrorResponse } from '../../applicationinfraestructure/interfaces/error-response';
import { IEdificios } from '../interfaces/Edificios';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-reporte-ventas',
  templateUrl: './reporte-ventas.component.html',
  styleUrls: ['./reporte-ventas.component.css']
})
export class ReporteVentasComponent implements OnInit {
  formReporte: FormGroup;
  filtros: IFiltrosReporte;
  submitted = false;
  error:any={isError:false,errorMessage:''};
  edificios: Array<IEdificios>;

  constructor(private excelService:ExcelService,
    private spinner: NgxSpinnerService,
    private readonly formBuilder: FormBuilder,
    private registroServicios: RegistroVentasService) { }

  ngOnInit(): void {
    this.construirFromularioReporte();
    this.getEdificiosConsulta(environment.edificiosAutorizados, environment.marcasAutorizadas);
  }

  construirFromularioReporte() {
    this.formReporte = this.formBuilder.group({
      fechaInicio: ['', Validators.required],
      fechaFin: ['', Validators.required],
      edificio: ['']
    });
  }
  get f() { return this.formReporte.controls; }

  getEdificiosConsulta(edificios: string, marcas: string) {
    this.registroServicios.getEdificiosConsulta(edificios, marcas).subscribe(
      resolve => {
        if (resolve.length != 0) {
          this.edificios = resolve;
        }

      },
      (error: ErrorResponse) => {
        console.error(error);
       
      }
    );
  }
 
  exportAsXLSX(): void {
    this.spinner.show();
    const filtros: IFiltrosReporte = {
      ...this.formReporte.value
    };

    this.registroServicios.getConsultaReporte(filtros).subscribe(
      resolve => {
        if (resolve.length != 0) {
          this.  excelService.exportAsExcelFile( resolve, 'reporte_ventas');
        }
        else
        {
          Swal.fire('No se encontraron registros.');
        }
        this.spinner.hide();
      },
      (error: ErrorResponse) => {
        console.error(error);
        this.spinner.hide();
      }
    );
  }

  compareTwoDates(){
    if((this.formReporte.controls['fechaFin'].value)<(this.formReporte.controls['fechaInicio'].value)){
       this.error={isError:true,errorMessage: 'La fecha fin no debe ser mayor a la fecha inicial'};
    }
    else{
     this.error={isError:false,errorMessage: ''};
    }
 }

}
